import store from '@/store'

// Helper function returns the object or an empty object fallback
function getPermission(appPageId) {
    const permissions = store.state.selectedTeamPermissions;
    if (!permissions) return {};
    
    return permissions.find(p => p.appPageId === appPageId) || {}
}

export function hasTeamAddRights(appPageId) {
    return !!getPermission(appPageId).add
}

export function hasTeamEditRights(appPageId) {
    return !!getPermission(appPageId).edit
}

export function hasTeamDeleteRights(appPageId) {
    return !!getPermission(appPageId).delete
}

export function hasTeamApproverRights(appPageId) {
    return !!getPermission(appPageId).approver
}

export function hasTeamSelfApproverRights(appPageId) {
    return !!getPermission(appPageId).selfApprover
}

export function hasTeamExportRights(appPageId) {
    return !!getPermission(appPageId).export
}
